import {ChartType} from './ChartType';

export const ChartHeights = {
    [ChartType.SUMMARY]: 20,
    [ChartType.DATA_TABLE]: 70,
    [ChartType.PERFORMANCE]: 50
};
